<template>
  <div id="app">

      <div class="update-banner" v-if="updateAvailable">
        A apărut o versiune nouă a meniului.
        <button @click="reload">Actualizează</button>
      </div>

      <router-view></router-view>

  </div>
</template>

<script lang="js">
    import settings from "@/backend/LocalSettings";

    export default {
        name: 'App',
        data() {
            return {
                updateAvailable: false
            }
        },
        methods:
        {
            async check_version()
            {
                var local_version  = settings.version;
                var server_version = await this.post("meniu/version");

                if( local_version != server_version )
                {
                    this.updateAvailable = true;
                }
            },
            reload(){
                window.location.reload();
            },
            post: async function(url, args={}){
                var response = await this.$http.post(url, args );
                return response.bodyText;
            },
        },
        mounted()
        {
            //verificam daca exista o versiune mai noua
            this.check_version();
        }
    }
</script>



<style lang="less">
/*
 * Design tokens - meniul digital
 * Tema se comuta prin atributul data-theme pe <html>
 * (setat din HomePage: preferinta sistem + toggle manual)
 */
:root {
  --m-bg:         #FCFBF8;
  --m-card:       #FFFFFF;
  --m-ink:        #23281F;
  --m-muted:      #79806F;
  --m-line:       #EAE7DD;
  --m-accent:     #4A6741;
  --m-accent-ink: #FDFCF8;
  --m-chip:       #F1EFE7;
  --m-hero1:      #33422E;
  --m-hero2:      #1F2A1C;
  --m-hero-ink:   #F4F1E6;
  --m-img-bg:     #EFEBDD;
}
:root[data-theme="dark"] {
  --m-bg:         #15170F;
  --m-card:       #1F221A;
  --m-ink:        #EDEBE0;
  --m-muted:      #9CA28E;
  --m-line:       #2E3227;
  --m-accent:     #9DB88A;
  --m-accent-ink: #1A2015;
  --m-chip:       #262A1F;
  --m-hero1:      #1C2418;
  --m-hero2:      #12180F;
  --m-hero-ink:   #F4F1E6;
  --m-img-bg:     #262B1E;
}

* { box-sizing: border-box; }

body {
  background: var(--m-bg);
  color: var(--m-ink);
  padding: 0;
  margin: 0;
  line-height: 1.5;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

/* fontul serif al meniului - nativ, fara webfonts, rapid pe 4G */
.serif {
  font-family: "Iowan Old Style", "Palatino Linotype", Palatino, Georgia, serif;
}

button { font-family: inherit; }

body.sheet-open {
  overflow: hidden;
}

.update-banner {
  position: fixed;
  bottom: 0; left: 0; right: 0;
  z-index: 200;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  background: var(--m-accent);
  color: var(--m-accent-ink);
  text-align: center;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;

  button {
    margin-left: 10px;
    background: var(--m-accent-ink);
    color: var(--m-accent);
    border: none;
    border-radius: 99px;
    padding: 4px 14px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
  }
}
</style>
